/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import Url from 'url-parse'
import MicroModal from 'micromodal'

import './styles.scss'

class RedirectModal {
  constructor (element) {
    this.$el = $(element)

    // Setup Modal
    MicroModal.init()

    // Open Modal if the store has changed
    const currentURL = new Url(window.location.href)

    if (currentURL.query.includes('store-changed=true')) {
      this.openModal()
    }
  }

  openModal () {
    MicroModal.show('redirect-modal', {
      disableScroll: true
    })
  }
}

registerClass('RedirectModal', RedirectModal)
